import React from 'react';
import { FillableSVGProps } from 'Src/types';

export default function AccountIcon({ filled, ...props }: FillableSVGProps) {
  if (filled) {
    return (
      <svg width="24" height="24" viewBox="0 0 13 20" fill="none" {...props}>
        <path d="M6.5 6C4.84315 6 3.5 4.65685 3.5 3C3.5 1.34315 4.84315 0 6.5 0C8.15685 0 9.5 1.34315 9.5 3C9.5 4.65685 8.15685 6 6.5 6Z" fill="currentcolor" />
        <path d="M6.5 7.5C3.18629 7.5 0.5 10.1863 0.5 13.5V18C0.5 18.8284 1.17157 19.5 2 19.5H11C11.8284 19.5 12.5 18.8284 12.5 18V13.5C12.5 10.1863 9.81371 7.5 6.5 7.5Z" fill="currentcolor" />
      </svg>
    );
  }

  return (
    <svg width="24" height="24" viewBox="0 0 12 20" fill="none" {...props}>
      <path d="M6 6C4.34315 6 3 4.65685 3 3C3 1.34315 4.34315 0 6 0C7.65685 0 9 1.34315 9 3C9 4.65685 7.65685 6 6 6ZM6 1.5C5.17157 1.5 4.5 2.17157 4.5 3C4.5 3.82843 5.17157 4.5 6 4.5C6.82843 4.5 7.5 3.82843 7.5 3C7.5 2.17157 6.82843 1.5 6 1.5Z" fill="currentcolor" />
      <path d="M6 7.5C2.68629 7.5 0 10.1863 0 13.5V18C0 18.8284 0.671573 19.5 1.5 19.5H10.5C11.3284 19.5 12 18.8284 12 18V13.5C12 10.1863 9.31371 7.5 6 7.5ZM6 9C8.48528 9 10.5 11.0147 10.5 13.5V18H1.5V13.5C1.5 11.0147 3.51472 9 6 9Z" fill="currentcolor" />
    </svg>
  );
}

AccountIcon.defaultProps = {
  filled: false,
};
